import DeleteIcon from '@assets/icons/delete.svg?react';
import { FC } from 'react';

export const DeleteModalWithConfirmInputIcon: FC = () => {
  return (
    <div className='flex size-12 items-center justify-center rounded-full bg-warning-100 text-warning-600'>
      <DeleteIcon className='size-6' aria-hidden='true' />
    </div>
  );
};
